/**
 * 数独题
 */
import QuestionSudoku from './view';

export default QuestionSudoku;



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/sudoku/index.js